export default __webpack_public_path__ + "static/media/oppo@2x.a94902e2.jpg";